// export const base_url = `http://192.168.1.6:8585`;

export const base_url = "https://engine.ihfc.candidate.mcitiservices.com";

export const webServiceUrl = {
  // Node Api's
  login: `${base_url}/login`,
  firstLogin: `${base_url}/firstLogin`,
  register: `${base_url}/register`,
  getProfile: `${base_url}/getProfile`,
  updateProfile: `${base_url}/updateProfile`,
  manageContact: `${base_url}/manageContact`,
  forgotPassword: `${base_url}/forgotPassword`,
  enrolledCourses: `${base_url}/enrolledCourses`,
  allPrograms: `${base_url}/allPrograms`,
  feedback_form: `${base_url}/feedback_form`,
  post_feedback_form: `${base_url}/post_feedback_form`,
  groupsEnrolled: `${base_url}/groupsEnrolledz`,
  upcoming_enrolled_requests: `${base_url}/upcoming_enrolled_requests`,
  alreadyEnrolled: `${base_url}/alreadyEnrolled`,
  resources: `${base_url}/resources`,
  lesson_plan: `${base_url}/lesson_plan`,
  download_pdf: `${base_url}/download-pdf `,
  show_attendence: `${base_url}/show_attendence `,
  mark_attendence: `${base_url}/mark_attendence `,
  upload_assignments: `${base_url}/upload_assignments `,
  score: `${base_url}/score `,
  getQueries: `${base_url}/getQueries `,
  replyOnQuery: `${base_url}/replyOnQuery `,
  sendQuery: `${base_url}/sendQuery `,
  getNotifications: `${base_url}/getNotifications `,
  post_community_thread: `${base_url}/post_community_thread `,
  get_community_threads: `${base_url}/get_community_threads `,
  delete_post: `${base_url}/delete_post `,
  like_post: `${base_url}/like_post `,
  like_comment: `${base_url}/like_comment `,
  post_comments: `${base_url}/post_comments `,
  threadsById: `${base_url}/threadsById `,

  //Profile API
  signIn: `${base_url}/signin`,
  // register: `${base_url}/register`,
  getUserData: `${base_url}/profile/get`,
  changePassword: `${base_url}/profile/change-password`,
  getAccountSettings: `${base_url}/account/settings`,
  postAccountSettings: `${base_url}/account/settings/update`,

  //Courses
  enrolled_courses: `${base_url}/courses/enrolled`,
  enrolled_courses_detials: `${base_url}/courses-enroll/details`,
  upcoming_courses: `${base_url}/upcoming-courses`,
  upcoming_courses_detials: `${base_url}/upcoming-course-details`,
  upcoming_courses_learning: `${base_url}/course-learning-outcomes`,

  //Advantage Club
  Iappreciated: `${base_url}/i-appreciated`,
  Inominated: `${base_url}//i-nominated`,

  //Groups
  get_groups: `${base_url}/get-groups`,
  get_groups_detail: `${base_url}/group-details`,
  get_group_posts: `${base_url}/group-posts`,
  appreciate_user: `${base_url}/appreciate-user`,
  nominateUserApi: `${base_url}/nominate-user`,

  //Notifications
  //Notifications
  user_notifications: `${base_url}/user-notifications`,

  //About Program Tabs
  about_ihfc: `${base_url}/about_ihfc`,
  about_program: `${base_url}/about_program`,
  program_schedule: `${base_url}/program_schedule`,
  team_oriented: `${base_url}/team_oriented`,
  spoc_details: `${base_url}/spoc_details`,
  wifi_access: `${base_url}/wifi_access`, 
  accommodation_info: `${base_url}/accommodation_info`,
  learning_outcomes: `${base_url}/learning_outcomes`,
  see_visit: `${base_url}/see_visit`,
  food_timing: `${base_url}/food_timing`,
  student_feedback_ques: `${base_url}/student_feedback_ques`,
  post_feedback_ques: `${base_url}/post_feedback_ques`,
  getLessonPlanDays: `${base_url}/getLessonPlanDays`,
  cohortRegistration: `${base_url}/cohort-registration`,
  get_community_threads: `${base_url}/get_community_threads`,
  delete_post: `${base_url}/delete_post`,
  post_community_thread: `${base_url}/post_community_thread`,
  room_feedback: `/room-feedback`,
  food_feedback: `/food-feedback`,
  get_food_feedback: `/get-food-feedback`,
  get_room_feedback: `/get-room-feedback`,
  all_programs: `${base_url}/all-programs`,
  register_user: `${base_url}/register-user`,
  verify_otp: `${base_url}/verify-otp`,
  resend_otp: `${base_url}/resend-otp`,
  generate_password: `${base_url}/generate-password`,
  post_traning: `${base_url}/post-feedback`,
  get_dashboard_details: `${base_url}/get-dashboard-details`,
  lesson_plan: `${base_url}/lesson_plan`,
  getLessonPlanDays: `${base_url}/getLessonPlanDays`,
  get_gallery_photo: `${base_url}/get-gallery-photo`,
  evaluation_group_details: `${base_url}/evaluation/group-details`,
  uploadReliving: `${base_url}/uploadReliving`,
  fetch_session_resource: `${base_url}/fetch-session-resource`,
  evaluation: `${base_url}/evaluation/`,
  list_trainer: `${base_url}/list-trainer`,
  post_comment: `${base_url}/post_comments`,
  is_Lead: `${base_url}/is-lead`,
  fetch_categories: `${base_url}/get-category`,
  get_domain: `${base_url}/get-domain`,
  get_course: `${base_url}/get-course`,
  // Enrolled Courses

  // getdataAPI: "https://jsonplaceholder.typicode.com/albums",
};
